export function parseErrors(input) {
  if (typeof input === 'object') return input;
  if (!input || typeof input !== 'string') {
    return {};
  }

  try {
    return JSON.parse(input);
  } catch (e) {
    return {};
  }
}

export function errorsContain(detail, errors) {
  if (typeof errors === 'string') {
    errors = parseErrors(errors).errors;
  }

  if (!Array.isArray(errors) || !detail) {
    return false;
  }

  return errors.some(e => {
    return e.detail && e.detail === detail;
  });
}

export function getErrorParamsFromError(detail, errors) {
  if (typeof errors === 'string') {
    errors = parseErrors(errors).errors;
  }

  if (!Array.isArray(errors)) {
    return null;
  }

  const match = errors.find(e => e.detail === detail);
  return match ? match.params : null;
}

export function getDetails(errors) {
  if (typeof errors === 'string') {
    errors = parseErrors(errors).errors;
  }

  if (!Array.isArray(errors)) {
    return [];
  }

  return errors.map(e => e.detail);
}
